import { motion } from "framer-motion";
import { useI18n } from "../i18n";

const HowItWorks = () => {
  const { t, lang } = useI18n();

  return (
    <section
      id="how"
      data-testid="how-section"
      className="section-light relative py-24 md:py-32 border-y border-[#e7d5de]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <div className="text-xs tracking-[0.25em] uppercase text-[#A60056] font-semibold mb-4">
            {lang === "pt" ? "Processo" : "Process"}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-[#1a0b12] text-balance">{t.how.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {t.how.steps.map((step, i) => (
            <motion.div
              key={`${lang}-${step.t}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
              className="relative p-7 md:p-8 rounded-2xl bg-white border border-[#eadbe3] hover:border-[#A60056]/40 shadow-[0_12px_44px_-20px_rgba(166,0,86,0.28)] transition-colors"
              data-testid={`step-${i}`}
            >
              <div className="text-6xl font-light text-[#A60056]/40 leading-none mb-6"
                   style={{ fontFamily: "'Outfit', sans-serif" }}>
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="text-xl text-[#1a0b12] font-medium mb-3">{step.t}</h3>
              <p className="text-[#5c4a54] text-[15px] leading-relaxed">{step.d}</p>
              {i < t.how.steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-3 w-6 h-px bg-gradient-to-r from-black/10 to-transparent" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
